<template>
  <div style="padding: 10px">
    <el-button style="margin-bottom: 10px" type="primary" icon="el-icon-plus"
      @click="openEditZoneDialog(true)">添加分区</el-button>

    <el-table :data="zoneList" border size="small" style="width: 1040px">
      <el-table-column prop="id" label="ID" align="center" width="70">
      </el-table-column>
      <el-table-column label="合入到哪个分区" align="center" width="70">
        <template scope="scope">
          <span>{{ scope.row.mergedIntoZoneId > 0 ? scope.row.mergedIntoZoneId : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="名称" align="center" width="150"></el-table-column>
      <el-table-column label="对外地址（http）" align="center" width="300">
        <template scope="scope">
          <span>{{ scope.row.mergedIntoZoneId > 0 ? `( ${scope.row.address} )` : scope.row.address }}</span>
        </template>
      </el-table-column>
      <el-table-column label="对内地址（grpc）" align="center" width="200">
        <template scope="scope">
          <span>{{ scope.row.mergedIntoZoneId > 0 ? `( ${scope.row.internalAddress} )` : scope.row.internalAddress }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center" width="100">
        <template scope="scope">
          <span v-if="scope.row.status == 0" class="zone-status-tag zone-status-tag-offline">隐藏</span>
          <span v-else-if="scope.row.status == 1" class="zone-status-tag zone-status-tag-maintained">维护</span>
          <span v-else-if="scope.row.status == 2" class="zone-status-tag zone-status-tag-idle">流畅</span>
          <span v-else-if="scope.row.status == 3" class="zone-status-tag zone-status-tag-full">爆满</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="150">
        <template scope="scope">
          <el-button type="danger" round size="mini" @click="deleteZone(scope.row.id, scope.row.name)">删除</el-button>
          <el-button type="primary" round size="mini" @click="openEditZoneDialog(false, scope.row)">修改</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- “编辑分区”对话框 -->
    <EditZoneDialog v-if="shouldEditZoneDialogVisible" @close="onEditZoneDialogClosed()" :value="valueForEditZoneDialog">
    </EditZoneDialog>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");

import EditZoneDialog from "./EditZoneDialog";

export default {
  data() {
    return {
      shouldEditZoneDialogVisible: false, // “添加邮件模板”对话框是否应该显示出来
      valueForEditZoneDialog: null, // 要传递给“编辑分区”对话框的数据
      zoneList: [], // 邮件模板列表里展示的数据
    };
  },

  created() {
    // 拉取分区集合
    this.loadZoneList();
  },

  components: {
    EditZoneDialog,
  },

  methods: {
    /**
     * 查询分区集合
     */
    async loadZoneList() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/getZoneList`,
          {},
          {
            headers: {
              token: util.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.zones || [];

      // 排序（按分区id倒序排列）
      listInResponse.sort((x, y) => {
        return y.id - x.id;
      });

      this.zoneList = listInResponse;
    },

    /**
     * 删除一个分区
     * @param {*} id
     * @param {*} name
     */
    async deleteZone(id, name) {
      try {
        // 弹确认框
        await this.$confirm(`确认删除分区“${name}”？`);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/deleteZone`,
            {
              id: id,
            },
            {
              headers: {
                token: util.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "删除成功",
          type: "success",
        });

        for (let i = 0; i < this.zoneList.length; i++) {
          if (this.zoneList[i].id == id) {
            this.zoneList.splice(i, 1);
          }
        }
      } catch (e) { }
    },

    /**
     * 打开“编辑分区”对话框
     */
    async openEditZoneDialog(isCreate, oldData) {
      this.shouldEditZoneDialogVisible = true;
      this.valueForEditZoneDialog = {
        isCreate: isCreate,
        oldData: oldData,
      };
    },

    /**
     * “编辑分区”对话框关闭了
     */
    async onEditZoneDialogClosed() {
      this.shouldEditZoneDialogVisible = false;

      // 重新拉取分区集合
      return this.loadZoneList();
    },
  },
};
</script>

<style lang="scss" scoped>
.zone-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}

.zone-status-tag-maintained {
  background-color: lightgray;
  border-color: lightgray;
}

.zone-status-tag-idle {
  background-color: chartreuse;
  border-color: chartreuse;
}

.zone-status-tag-full {
  background-color: rgb(243, 159, 159);
  border-color: red;
}
</style>